import React, { useEffect, useState, useMemo, useContext } from "react";
import Layout from "../layout/Layout";
import { Link, useNavigate } from "react-router-dom";
import { FilePdfOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { Breadcrumb, Col, Row } from "antd";
import SummaryContent from "../components/company-summary/SummaryContent";
import SummaryHeader from "../components/company-summary/SummaryHeader";
import {
  getCompanyDetails,
  getEmployeeList,
  getDepartmentList,
  getSimilarCompanyList,
  downloadCompany,
} from "../actionCreator/companyDetailsActionCreator";
import { useParams } from "react-router-dom";
import "../assets/css/dynemic-page.css";
import Loader from "../components/loader";
import SimilarCompany from "../components/company-summary/similarCompany";
import CompanyPdfFormat from "../components/company-summary/CompanyPdfFormat";
import jsPDF from "jspdf";
import popupImg from "../assets/images/free-user-login-prompt.jpg.jpeg";
import TrialModal from "../common/TrialModal";
import { AuthContext } from "../context/AuthContext";
import { useAlert } from "../context/AlertProvider";
import Meta from "./../pages/Meta";

const CompanySummary = () => {
  const { id } = useParams();
  const { isAuthenticated: isLoggedIn } = useContext(AuthContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const companyDetails = useSelector(
    (state) => state.companyDetailsReducer.companyDetails
  );
  const { isCompanyView } = useContext(AuthContext);

  useEffect(() => {
    if (!isCompanyView && isLoggedIn) {
      navigate("/dashboard-view");
    }
  }, [isCompanyView, navigate, isLoggedIn]);

  useMemo(() => {
    dispatch(getDepartmentList());
    dispatch(getCompanyDetails(id));
    dispatch(getEmployeeList(id));
  }, [id]);

  useMemo(() => {
    if (Object.keys(companyDetails).length) {
      dispatch(
        getSimilarCompanyList(
          {
            selectedIndustry: companyDetails?.industry
              ? [companyDetails?.industry]
              : [{ id: 0 }],
            cid: companyDetails?.id,
          },
          {
            start: 0,
            end: 10,
          }
        )
      );
    }
  }, [companyDetails]);

  useEffect(() => {
    Object.keys(companyDetails).length ? setLoading(false) : setLoading(false);
  }, [Object.keys(companyDetails).length]);

  const downloadPDF = async () => {
    if (isLoggedIn) {
      const res = await dispatch(downloadCompany([companyDetails?.id], "pdf"));
      if (res) {
        let jsPdf = new jsPDF("p", "pt", "letter");
        var htmlElement = document.getElementById("doc-target");

        htmlElement.querySelectorAll("td, th").forEach((cell) => {
          cell.style.whiteSpace = "pre-wrap";
          cell.style.letterSpacing = "0.5px";
          cell.style.whiteSpace = "normal";
          cell.style.wordBreak = "break-word";
        });

        const opt = {
          callback: function (jsPdf) {
            jsPdf.save(`${companyDetails?.name}.pdf`);
            showAlert(
              "success",
              "Download Complete",
              <div>
                The company details for {companyDetails?.name} have been
                successfully downloaded to{" "}
                <FilePdfOutlined style={{ color: "#f44336" }} />.
              </div>
            );
          },
          margin: [30, 30, 30, 30],
          autoPaging: "text",
          html2canvas: {
            useCORS: true,
            allowTaint: true,
            dpi: 300,
            letterRendering: true,
            logging: false,
            scale: 0.8,
          },
        };

        jsPdf.html(htmlElement, opt);
      }
    } else {
      setShowModal(true);
    }
  };

  return (
    <>
      <Meta
        title={`${companyDetails?.name} Email ID | Official Contacts`}
        description={`Get the ${companyDetails?.name} Email ID of Employees including CEO, HR, Marketer etc. All emails are human verified & 100% accurate.`}
      />

      <Layout>
        {!loading ? (
          <div className="wrapper companysummary padd-90">
            <Breadcrumb
              items={[
                {
                  title: (
                    <Link to={isLoggedIn ? "/dashboard-view" : "/"}>Home</Link>
                  ),
                },
                {
                  title: <Link to="/search-company">Search Company</Link>,
                },
                {
                  title: "Company Summary",
                },
              ]}
              className="text-uppercase"
            />

            <Row gutter={[20, 20]} className="justify-content-between">
              <Col xs={24} lg={16} xl={18}>
                <SummaryHeader downloadPDFCallback={downloadPDF} />

                <SummaryContent />
              </Col>
              <Col xs={24} lg={8} xl={6} className="mt-4">
                <SimilarCompany />
              </Col>
            </Row>
          </div>
        ) : (
          <Loader />
        )}
      </Layout>

      {showModal && (
        <TrialModal
          openModal={showModal}
          closeModal={() => setShowModal(false)}
          redirectToSignup={() => {
            setShowModal(false);
            navigate("/signup");
          }}
          redirect={true}
          buttonText="Start Free Trial"
          modalBody={
            <div id="small-dialog2">
              <div align="center">
                <img src={popupImg} alt="" />
              </div>
              <p style={{ color: "#0000FF" }}>
                Get 10 free verified contacts with a BeyondLeadz Pro trial
              </p>
              <p>
                BeyondLeadz Pro customers close deals faster thanks to relevant
              </p>
            </div>
          }
          modalWidth="400px"
        />
      )}
      <div style={{ position: "absolute", left: "-5000px", top: "-5000px" }}>
        <div id="doc-target">
          <CompanyPdfFormat />
        </div>
      </div>
    </>
  );
};

export default CompanySummary;
